import { useEffect } from "react";
import { apiService } from "../constants/ApiService";


// ======================= API FUNCATION  ================
const getMasterRegistryByName = async (masterName, bussinessMode) => {
    let queryString = `masterName=${masterName}`;

    if (bussinessMode) {
        queryString += `&working_bussinesss_mode=${bussinessMode}`;
    }

    return await apiService.get(
        `api/Master_Registry/ObjectByMasterName?${queryString}`,
        {
            headers: {
                'Content-Type': 'application/json',
                accept: 'application/json'
            }
        }
    );
};


export const useMasterRegistry = ({
    masterName,
    user,
    setState,
    superAdminDefaults
}) => {

    useEffect(() => {
        // debugger;
        if (user.working_bussinesss_mode && user.user_profile !== "superadmin") {
            loadMaster();
        } else {
            setState(prev => ({
                ...prev,
                ...superAdminDefaults
            }));
        }
    }, [user.working_bussinesss_mode, masterName]);

    const loadMaster = async () => {
        try {
            const response = await getMasterRegistryByName(
                masterName,
                user.working_bussinesss_mode
            );

            if (response.status === true) {
                setState(prev => ({
                    ...prev,
                    ...response.system_DynamicObject
                }));
            }
        } catch (err) {
            console.error(err);
        }
    };
};
